export const ERROR_MESSAGES = {
  UNABLE_TO_CONNECT: 'systemReady.unableToConnect',
  ERROR_MESSAGE: 'systemReady.healthErrorMessage',
} as const;
